import React, { Component } from 'react';
import { Localized } from '@fluent/react';

import AppShell from '../AppShell';
import ContentDoc from './ContentDoc';
import EmptyState from '../EmptyState';
import Spinner from '../Spinner';
import { prettyDate } from '../../tools/date';
import './Report.scss';
import postTranslations from '../../controllers/postTranslation';
import {
  addDynamicDetail,
  getDynamicDetail,
  updateDynamicDetail,
} from '../../dbDynamic';
import { Button } from 'reactstrap';
import { ReactComponent as Globe } from '../../assets/globe-alt.svg';

export default class Dynamic extends Component {
  state = {
    translateLoading: false,
    reportTranslatedTitle: '',
    reportTranslatedText: '',
    reportTranslatedCat: [],
    reportsCached: [],
    clickedShowOriginal: false,
    clickedTranslate: false,
  };

  // Workaround
  getEscapedString = string => {
    const el = document.createElement('textarea');
    el.innerHTML = string;
    return encodeURIComponent(el.innerText);
  };

  populateReports = () => {
    const paramId = parseInt(this.props.match.params.id);
    const pageType = this.props.match.params.category;
    const result = getDynamicDetail(pageType);
    result.then(data => this.setState({ reportsCached: data }));
    result.then(data => {
      if (data.length > 0) {
        const filteredReport =
          data.length > 0 && data.filter(item => item.idReport === paramId)[0];
        this.setState({
          reportTranslatedTitle: filteredReport?.title,
        });
        this.setState({
          reportTranslatedText: filteredReport?.text,
        });
        this.setState({
          reportTranslatedCat: filteredReport?.categories?.split(','),
        });
      }
    });
  };

  compareUpdateDate = () => {
    const { dynamic } = this.props;
    const paramId = parseInt(this.props.match.params.id);
    const pageType = this.props.match.params.category;
    const result = getDynamicDetail(pageType);
    result.then(data => {
      if (data.length > 0) {
        const filteredReport =
          data.length > 0 && data.filter(item => item.idReport === paramId)[0];
        const dateFiltered = Math.floor(
          new Date(filteredReport?.updateDate).getTime() / 1000
        );
        const reportDate = Math.floor(
          new Date(dynamic?.modified).getTime() / 1000
        );
        if (dateFiltered !== reportDate && !isNaN(reportDate)) {
          this.getTranslactionsUpdate();
        }
      }
    });
  };

  getTranslactions = () => {
    const { dynamic } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const reportToTranslate = {
      title: dynamic?.title?.rendered,
      text: dynamic?.content?.rendered,
      categories: dynamic?.page_category.map(item => item.name),
    };
    const pageType = this.props.match.params.category;
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        {
          title: reportToTranslate.title,
          text: reportToTranslate.text,
          categories: `${reportToTranslate.categories}`,
        },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            reportTranslatedTitle: reportToTranslate.title,
          });
          this.setState({
            reportTranslatedText: reportToTranslate.text,
          });
          this.setState({
            reportTranslatedCat: reportToTranslate.categories,
          });
          this.setState({ translateLoading: false });
        } else {
          addDynamicDetail(
            {
              title: res?.translation?.title,
              text: res?.translation?.text,
              categories: res?.translation?.categories,
              idReport: dynamic.id,
              updateDate: dynamic.modified,
            },
            pageType
          );
          this.populateReports();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  getTranslactionsUpdate = () => {
    const { dynamic } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const reportToTranslate = {
      title: dynamic?.title?.rendered,
      text: dynamic?.content?.rendered,
      categories: dynamic?.page_category.map(item => item.name),
    };
    const pageType = this.props.match.params.category;
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        {
          title: reportToTranslate.title,
          text: reportToTranslate.text,
          categories: `${reportToTranslate.categories}`,
        },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            reportTranslatedTitle: reportToTranslate.title,
          });
          this.setState({
            reportTranslatedText: reportToTranslate.text,
          });
          this.setState({
            reportTranslatedCat: reportToTranslate.categories,
          });
          this.setState({ translateLoading: false });
        } else {
          updateDynamicDetail(
            dynamic.id,
            {
              title: res?.translation?.title,
              text: res?.translation?.text,
              categories: res?.translation?.categories,
              idReport: dynamic.id,
              updateDate: dynamic.modified,
            },
            pageType
          );
          this.populateReports();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  componentDidMount() {
    const lang = localStorage.getItem('language');
    if (lang !== 'it-IT') {
      this.populateReports();
      this.compareUpdateDate();
    }
  }

  componentDidUpdate(prevProps) {
    const { reportsCached } = this.state;
    if (this.props.dynamic?.id !== prevProps.dynamic?.id) {
      const { dynamic } = this.props;
      const filteredReport =
        reportsCached.length > 0 &&
        reportsCached.filter(item => item.idReport === dynamic.id)[0];
      if (!filteredReport) {
        this.getTranslactions();
      } else {
        const dateFiltered = Math.floor(
          new Date(filteredReport.updateDate).getTime() / 1000
        );
        const reportDate = Math.floor(
          new Date(dynamic.modified).getTime() / 1000
        );
        if (dateFiltered !== reportDate) {
          this.getTranslactionsUpdate();
        }
      }
    }
  }

  showOriginal = () => {
    const { dynamic } = this.props;
    this.setState({
      reportTranslatedTitle: dynamic?.title?.rendered,
    });
    this.setState({
      reportTranslatedText: dynamic?.content?.rendered,
    });
    this.setState({
      reportTranslatedCat: dynamic?.page_category.map(item => item.name),
    });
    this.setState({ clickedShowOriginal: true });
    this.setState({ clickedTranslate: false });
  };

  translateReport = () => {
    this.setState({ clickedShowOriginal: false });
    this.setState({ clickedTranslate: true });
    const paramId = parseInt(this.props.match.params.id);
    const pageType = this.props.match.params.category;
    const { dynamic } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang === 'it-IT' ? 'en' : lang.split('-')[0];
    const reportToTranslate = {
      title: dynamic?.title?.rendered,
      text: dynamic?.content?.rendered,
      categories: dynamic?.page_category.map(item => item.name),
    };
    const result = getDynamicDetail(pageType);
    result.then(data => {
      if (data.length > 0) {
        const filteredReport =
          data.length > 0 && data.filter(item => item.idReport === paramId)[0];
        if (dynamic.id !== filteredReport?.idReport) {
          this.setState({ translateLoading: true });
          postTranslations(
            {
              title: reportToTranslate.title,
              text: reportToTranslate.text,
              categories: `${reportToTranslate.categories}`,
            },
            language
          ).then(res => {
            if (
              !res ||
              (res && res.ok === false) ||
              (res && res?.status >= 400 && res?.status < 600)
            ) {
              this.setState({
                reportTranslatedTitle: reportToTranslate.title,
              });
              this.setState({
                reportTranslatedText: reportToTranslate.text,
              });
              this.setState({
                reportTranslatedCat: reportToTranslate.categories,
              });
              this.setState({ translateLoading: false });
            } else {
              addDynamicDetail(
                {
                  title: res?.translation?.title,
                  text: res?.translation?.text,
                  categories: res?.translation?.categories,
                  idReport: dynamic.id,
                  updateDate: dynamic.modified,
                },
                pageType
              );
              this.populateReports();
              this.setState({ translateLoading: false });
            }
          });
        } else {
          const dateFiltered = Math.floor(
            new Date(filteredReport?.updateDate).getTime() / 1000
          );
          const reportDate = Math.floor(
            new Date(dynamic.modified).getTime() / 1000
          );
          if (dateFiltered !== reportDate) {
            this.setState({ translateLoading: true });
            postTranslations(
              {
                title: reportToTranslate.title,
                text: reportToTranslate.text,
                categories: `${reportToTranslate.categories}`,
              },
              language
            ).then(res => {
              if (
                !res ||
                (res && res.ok === false) ||
                (res && res?.status >= 400 && res?.status < 600)
              ) {
                this.setState({
                  reportTranslatedTitle: reportToTranslate.title,
                });
                this.setState({
                  reportTranslatedText: reportToTranslate.text,
                });
                this.setState({
                  reportTranslatedCat: reportToTranslate.categories,
                });
                this.setState({ translateLoading: false });
              } else {
                updateDynamicDetail(
                  dynamic.id,
                  {
                    title: res?.translation?.title,
                    text: res?.translation?.text,
                    categories: res?.translation?.categories,
                    idReport: dynamic.id,
                    updateDate: dynamic.modified,
                  },
                  pageType
                );
                this.populateReports();
                this.setState({ translateLoading: false });
              }
            });
          } else {
            this.setState({
              reportTranslatedTitle: filteredReport?.title,
            });
            this.setState({
              reportTranslatedText: filteredReport?.text,
            });
            this.setState({
              reportTranslatedCat: filteredReport?.categories?.split(','),
            });
          }
        }
      } else {
        this.setState({ translateLoading: true });
        postTranslations(
          {
            title: reportToTranslate.title,
            text: reportToTranslate.text,
            categories: `${reportToTranslate.categories}`,
          },
          language
        ).then(res => {
          if (
            !res ||
            (res && res.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              reportTranslatedTitle: reportToTranslate.title,
            });
            this.setState({
              reportTranslatedText: reportToTranslate.text,
            });
            this.setState({
              reportTranslatedCat: reportToTranslate.categories,
            });
            this.setState({ translateLoading: false });
          } else {
            addDynamicDetail(
              {
                title: res?.translation?.title,
                text: res?.translation?.text,
                categories: res?.translation?.categories,
                idReport: dynamic.id,
                updateDate: dynamic.modified,
              },
              pageType
            );
            this.populateReports();
            this.setState({ translateLoading: false });
          }
        });
      }
    });
  };

  render() {
    const { isLoading, match, dynamic, user } = this.props;
    const {
      reportTranslatedText,
      reportTranslatedTitle,
      reportTranslatedCat,
      translateLoading,
      clickedShowOriginal,
      clickedTranslate,
    } = this.state;
    const lang = localStorage.getItem('language');
    if (isLoading) {
      return (
        <AppShell noFilterBar match={match} user={user}>
          <div className="container pXXLarge">
            <div className="hero-unit text-center">
              <Spinner />
            </div>
          </div>
        </AppShell>
      );
    } else if (!dynamic || !dynamic.title) {
      return (
        <AppShell noFilterBar match={match} user={user}>
          <div className="container pXXLarge">
            <div className="hero-unit text-center">
              <EmptyState
                img="/img/report.svg"
                label={
                  <Localized id="no_pages_found">no_pages_found</Localized>
                }
              />
            </div>
          </div>
        </AppShell>
      );
    }

    const { page_category, content, date, modified, title, pageType } = dynamic;
    return (
      <AppShell noFilterBar match={match} user={user}>
        <div className={`row justify-content-center ${pageType}`}>
          <div className="col col-12 col-lg-12">
            <div className="card mb-4 report-content">
              <div className="reportHeader">
                {translateLoading ? (
                  <div className="translatingText">translating...</div>
                ) : (lang !== 'it-IT' && !clickedShowOriginal) ||
                  clickedTranslate ? (
                  <Button
                    color="primary"
                    className="reportButton"
                    onClick={this.showOriginal}
                  >
                    <Globe className="imgReportButton" />
                    <Localized id="report_detail_show_original">
                      report_detail_show_original
                    </Localized>
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    className="reportButton"
                    onClick={this.translateReport}
                  >
                    <Globe className="imgReportButton" />
                    <Localized id="report_detail_translate_btn">
                      report_detail_translate_btn
                    </Localized>
                  </Button>
                )}
              </div>
              <div className="card-body">
                <div className="report-title page-title">
                  <div className="row">
                    <div className="col-12">
                      <h1
                        className="report-title-h1"
                        dangerouslySetInnerHTML={{
                          __html:
                            (lang === 'it-IT' && !clickedTranslate) ||
                            translateLoading
                              ? title.rendered
                              : reportTranslatedTitle,
                        }}
                      />
                    </div>
                    <div className="col-12">
                      <div className="badge report-tags">
                        {page_category.map((tag, i) => (
                          <span
                            className="badge report-tag"
                            key={tag.id}
                            dangerouslySetInnerHTML={{
                              __html:
                                (lang === 'it-IT' && !clickedTranslate) ||
                                translateLoading
                                  ? tag.name
                                  : reportTranslatedCat?.[i],
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {page_category[0].slug === 'documentazione' ? (
                  <ContentDoc content={dynamic.content}></ContentDoc>
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        (lang === 'it-IT' && !clickedTranslate) ||
                        translateLoading
                          ? content.rendered
                          : reportTranslatedText,
                    }}
                  />
                )}

                <div className="report-metadata">
                  <p>
                    <Localized id="date_publication">
                      date_publication
                    </Localized>
                    : {prettyDate(new Date(date))}
                  </p>
                  <p>
                    <Localized id="date_update">date_update</Localized>:{' '}
                    {prettyDate(new Date(modified))}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppShell>
    );
  }
}
